import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { DrawerRef } from "mis-design-system/drawer";
import { DRAWER_DATA_VAR } from "mis-design-system/drawer";
import { ToastService } from "mis-crystal-design-system/toast";
import { Subject } from "rxjs";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { ApiService } from "../../../services/api.service";
import { BookingDataService } from "../../../services/booking-data.service";
import { LoaderService } from "../../../services/loader.service";
import { BookingConfirmationComponent } from "../../forms/booking-confirmation/booking-confirmation.component";
import { ConfigurationService } from "../../../services/configuration.service";
import { DrawerService } from "mis-design-system/drawer";
import { AddonWrapperComponent } from "../addon-wrapper/addon-wrapper.component";
import { ModalService } from "mis-design-system/mis-modal";
import { RecurrenceBookingSuccessComponent } from "../recurrence-booking-success/recurrence-booking-success.component";

@Component({
  selector: "mis-employee-web-exp-booking",
  templateUrl: "./booking.component.html",
  styleUrls: ["./booking.component.scss"]
})
export class BookingComponent implements OnInit, OnDestroy {
  constructor(
    private drawerRef: DrawerRef,
    private bookingSvc: BookingDataService,
    @Inject(DRAWER_DATA_VAR) configs,
    private apiService: ApiService,
    private drawerSvc: DrawerService,
    private loader: LoaderService,
    private toast: ToastService,
    private configSvc: ConfigurationService,
    private modals: ModalService
  ) {
    this.configs = configs;
  }

  configs: NsEmpWebExpData.IBookingFormConfig;
  private endObs = new Subject<void>();

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }

  requestCreateBookings(request: [NsEmpWebExpData.IBookingRequest[] | NsEmpWebExpData.IBookingRequestObject, boolean]): void {
    const bookings = request[0];
    const recurrenceEnabled = request[1];
    this.loader.show("This may take a few seconds...");
    if (recurrenceEnabled) {
      this.apiService.createRecurrenceBookings(bookings).subscribe(res => {
        this.loader.hide();
        this.bookingSvc.createRecurrenceResp = res;
        this.modals.show(RecurrenceBookingSuccessComponent, bookings, { closeOnBackdropClick: false });
        this.drawerRef.close("DONE");
      });
    } else {
      this.apiService.createBookings(bookings).subscribe(res => {
        const err = res.find(r => r.error);
        this.loader.hide();
        if (err) {
          this.toast.displayMsg(err.errorMessage);
          // this.drawerRef.close();
          return;
        }
        this.bookingSvc.createResp = res?.[0];
        this.modals.show(BookingConfirmationComponent, this.configs.userConfigs, { closeOnBackdropClick: true });
        this.drawerRef.close("DONE");
      });
    }
  }

  requestUpdateBookings(bookings: NsEmpWebExpData.IBookingRequest[]): void {
    this.loader.show();
    this.apiService.updateBookings(bookings).subscribe(res => {
      this.loader.hide();
      const err = res.find(r => r.error);
      if (err) {
        this.toast.displayMsg(err.errorMessage);
        // this.drawerRef.close();
        return;
      }
      const schErr = res.find(r => r.errorMessageForLogInTransport || r.errorMessageForLogoutTranseport);
      if (schErr) {
        this.toast.displayMsg(`${schErr.errorMessageForLogInTransport || schErr.errorMessageForLogoutTranseport}`, 10000);
      } else {
        this.toast.displayMsg("Your booking has been updated");
      }
      this.drawerRef.close("DONE");
    });
  }

  close(data?): void {
    this.drawerRef.close(data);
  }

  expand(addon: { addon: NsEmpWebExpData.IAddon; shiftValid: boolean }): void {
    if (this.configSvc.isMobile && addon.addon.id) {
      if (!addon.shiftValid) {
        this.toast.displayMsg("Please select both check in and check out to view seats");
        return;
      }
      this.drawerSvc.show(AddonWrapperComponent, addon.addon, { width: "100%" });
      return;
    } else {
      this.drawerRef.expand();
    }
  }
}
